// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { commonActions } from "./common-actions";
import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";
import { environmentCommonFields } from "./environment-common-fields";
import { environmentCommonObjects } from "./environment-common-objects";
import { environmentCommonValues } from "./environment-common-values";

export const environmentTopologyVersions = {
  title: "拓扑版本",
  subtitle: "拓扑模板的冻结快照、发布对象与血缘承载层。",
  summaryTotal: "总数",
  summaryPublished: environmentCommonValues.status.published,
  summaryDraft: environmentCommonValues.status.draft,
  summaryArchived: environmentCommonValues.status.archived,
  summaryShared: environmentCommonValues.visibility.shared,
  columns: {
    code: commonShortFieldLabels.code,
    name: "拓扑版本",
    imageIdentifier: "版本标识",
    imageTitle: "版本名称",
    status: commonShortNouns.status,
    shareMode: environmentCommonFields.shareMode,
    versionNo: "版本号",
    nodeCount: "节点数",
    networkCount: "网络数",
    accessPointCount: "接入点数",
    roleCount: "角色数",
    derivationType: "派生类型",
    tags: environmentCommonFields.tags,
    description: environmentCommonFields.description,
    createdAt: commonShortFieldLabels.createdAt,
    actions: commonShortNouns.actions,
  },
  actions: {
    refresh: commonActions.refresh,
    viewDetail: "查看",
    share: commonActions.share,
  },
  forms: {
    topologyTemplate: environmentCommonObjects.topologyTemplate,
    displayName: environmentCommonFields.displayName,
    description: commonShortFieldLabels.description,
    tags: environmentCommonFields.tags,
    tagsPlaceholder: "逗号分隔，例如 published, web",
    requiredTopologyTemplate: "请选择拓扑模板",
    requiredStatus: "请选择状态",
    requiredShareMode: "请选择共享方式",
  },
  scopes: {
    mine: "我的",
    shared_with_me: "共享给我",
    public: "公共",
    all: "全部",
  },
  shareMode: {
    private: environmentCommonValues.visibility.private,
    shared_to_users: "定向共享",
    public: "公共",
  },
  share: {
    title: "共享拓扑版本",
    notice:
      "共享设置已从拓扑版本编辑中独立出来。编辑抽屉只维护版本元数据，共享关系请在这里单独治理。",
    publicDescription: "共享到公共区后，任何有该平台入口读取资格的用户都可见该拓扑版本。",
    selectedUsersTitle: "已共享用户",
    emptyUsers: "当前还没有定向共享用户",
    actions: {
      pickUsers: "从组织中选择用户",
    },
    fields: {
      capabilities: "授予能力",
    },
    capabilities: {
      view: "查看",
      reference: "引用",
      clone: "克隆",
    },
    errors: {
      selectAtLeastOneUser: "请选择至少一个共享用户",
      selectCapabilities: "请至少选择一个共享能力",
    },
    messages: {
      saveSuccess: "拓扑版本共享设置已保存",
      saveFailed: "拓扑版本共享设置保存失败",
    },
  },
  drawers: {
    topologyViewSnapshot: environmentCommonObjects.topologyViewSnapshot,
  },
  preview: {
    title: "拓扑预览",
    ariaLabel: "拓扑版本视图快照预览",
    empty: "当前版本没有可预览的 X6 视图快照。",
    readonlyDescription: "这里只读展示当前拓扑版本冻结下来的 X6 视图快照，不提供编辑能力。",
  },
  status: {
    published: environmentCommonValues.status.published,
  },
  errors: {
    loadFailed: "加载拓扑版本失败",
  },
} as const;
